import { createSlice } from "@reduxjs/toolkit";
import { AgentGlobalSearch } from "./AgentSearchAction";
interface ISearchItem {
  container: string;
}

interface IAgentGlobalSearchData {
  searchList: ISearchItem[];
  isMorethanTen: boolean;
}

interface ISearchListSlice {
  agentGlobalSearchData: IAgentGlobalSearchData | null;
}
const initialState: ISearchListSlice = {
  agentGlobalSearchData: null,
};
const agentGlobalSearchSlice = createSlice({
  name: "globalSearch",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(AgentGlobalSearch.fulfilled, (state, { payload }) => {
      state.agentGlobalSearchData = payload.data;
    });
  },
});

export default agentGlobalSearchSlice.reducer;
